export const settings = {
  theme: process.env.REACT_APP_THEME ? process.env.REACT_APP_THEME : "default",
  localization: {
    defaultLocaleIdentifiers: ["en-US", "en"],
    messageIdProvider: {
      prefix: "paris"
    },
    messagePrefixes: ["paris", "ui-common"]
  },
  translation: {
    cacheRefreshTimeInSeconds: 300,
    useLocalTranslations: process.env.REACT_APP_USE_LOCAL_TRANSLATIONS === "1"
  }
};
